import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { LoadingSpinner } from '../../../LoadingSpinner';
import { TableButton } from '../../../TableButton';
import { SortIndicator } from '../../../SortIndicator';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { ComparisonHelper } from '../../../helpers/ComparisonHelper';
import { SearchHelper } from '../../../helpers/SearchHelper';

export class MapPointsDraft extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "name",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    sortMapPoints(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    compareStopsLength(stops) {
        return stops.length;
    }

    // -----------------------

    renderLoading(isLoading) {
        if(isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if(property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderStopsLength(mapPoint) {
        if (undefined === mapPoint.stops) {
            return '0';
        }

        return mapPoint.stops.length;
    }

    render() {
        const { render } = this.state;
        const { mapPoints, isLoading, currentPage, elementsPerPage, filter } = this.props;

        let mapPointsFiltered = SearchHelper.search({
            filter: filter,
            data: mapPoints,
            fields: ["name", "latitude", "longitude", "addInfo", "stops"],
            callbackComparison: [{ "stops": (a) => this.compareStopsLength(a) }]
        });

        const totalPages = PaginationHelper.getTotalPages(mapPointsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const mapPointsToRender = mapPointsFiltered.sort((a, b) => this.sortMapPoints(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                <th className="sortable" onClick={() => this.onChangeSort("latitude")}>Latitude {this.renderSortIndicator("latitude", render.sort)}</th>
                                <th className="sortable" onClick={() => this.onChangeSort("longitude")}>Longitude {this.renderSortIndicator("longitude", render.sort)}</th>
                                <th className="sortable" onClick={() => this.onChangeSort("addInfo")}>Informação Adicional {this.renderSortIndicator("addInfo", render.sort)}</th>
                                <th>Paragens Associadas</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                mapPointsToRender.map((mapPoint, idx) =>
                                    <tr key={`map-point-${idx}`} className={ComparisonHelper.getRowClass(mapPoint.name)}>
                                        <td>{ComparisonHelper.renderProperty(mapPoint.name)}</td>
                                        <td>{ComparisonHelper.renderProperty(mapPoint.latitude)}</td>
                                        <td>{ComparisonHelper.renderProperty(mapPoint.longitude)}</td>
                                        <td>{ComparisonHelper.renderProperty(mapPoint.addInfo)}</td>
                                        <td>{this.renderStopsLength(mapPoint)}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(mapPoint)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(mapPoint)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={mapPointsFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/mapPoints/providerMapPoints/MapPointsDraft.js